export enum CustomerType {
  company = 'CMP',
  individual = 'IND'
}
